import {
  ArchiveProgrammeRequest,
  CreateProgrammeRequest,
  PublishProgrammeRequest,
  UpdateParentProgrammeRequest,
  UpdateSubProgrammeRequest,
  ViewParentProgrammeRequest,
  ViewSubProgrammeRequest
} from './programme.types';

import {
  API_HOST,
  HttpGetOptions,
  HttpPostOptions,
  HttpPutOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../../utils/api.util';

const getEndpoint = () => `${API_HOST}/v2/programmes`;
const getSpecificEndpoint = (externalReference: string) => `${getEndpoint()}/${externalReference}`;

export const getViewAllProgrammesRequest = (): [string, HttpGetOptions] => [getEndpoint(), getHttpGetOptions()];

export const getCreateProgrammeRequest = (
  data: CreateProgrammeRequest
): [string, HttpPostOptions<CreateProgrammeRequest>] => [getEndpoint(), getHttpPostOptions(data)];

export const getViewParentProgrammeRequest = (data: ViewParentProgrammeRequest): [string, HttpGetOptions] => [
  `${getSpecificEndpoint(data.programmeExternalReference)}/general`,
  getHttpGetOptions()
];

export const getViewSubProgrammeRequest = (data: ViewSubProgrammeRequest): [string, HttpGetOptions] => [
  `${getSpecificEndpoint(data.programmeExternalReference)}/sub-programmes/${
    data.subProgrammeExternalReference
  }/general`,
  getHttpGetOptions()
];

export const getUpdateParentProgrammeRequest = (
  data: UpdateParentProgrammeRequest
): [string, HttpPutOptions<UpdateParentProgrammeRequest['payload']>] => [
  `${getSpecificEndpoint(data.programmeExternalReference)}/general`,
  getHttpPutOptions(data.payload)
];

export const getUpdateSubProgrammeRequest = (
  data: UpdateSubProgrammeRequest
): [string, HttpPutOptions<UpdateSubProgrammeRequest['payload']>] => [
  `${getSpecificEndpoint(data.programmeExternalReference)}/sub-programmes/${
    data.subProgrammeExternalReference
  }/general`,
  getHttpPutOptions(data.payload)
];

export const getPublishProgrammeRequest = (data: PublishProgrammeRequest): [string, HttpGetOptions] => [
  `${getSpecificEndpoint(data.programmeExternalReference)}/activate`,
  getHttpGetOptions()
];

export const getArchiveProgrammeRequest = (
  data: ArchiveProgrammeRequest
): [string, HttpPutOptions<ArchiveProgrammeRequest>] => [
  `${getSpecificEndpoint(data.programmeExternalReference)}/archive`,
  getHttpPutOptions(data)
];
